/* External Imports */
import { Box, Image } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';
import SannidhiSectionTitle from './SannidhiSectionTitle';
import SliderImageGallery from './SliderImageGallery';

/* Services */

/**
 * Renders the Sannidhi Space content component
 *
 * @param {object} sectionContent - Data for section
 * @returns {ReactElement} Sannidhi Space content component
 */

const SannidhiSpace = sectionContent => {
  const moduledata = sectionContent.pageBody;
  return (
    <Box as="div">
      <SannidhiSectionTitle titleObj={moduledata[0]} />
      <Box as="div" mt={{ base: '40px', md: '20px' }}>
        <SliderImageGallery sectionContent={moduledata[1]} />
      </Box>
      <Box
        as="h2"
        textAlign="center"
        color="#28231E"
        fontFamily="FedraSerifAStdBook"
        fontSize={{ base: '24px', sm: '24px', md: '34px', lg: '34px' }}
        fontWeight="bold"
        lineHeight="34px"
        width={{ base: '75%', sm: '75%', md: 'auto', lg: 'auto' }}
        m={{
          base: '30px auto 15px auto',
          sm: '30px auto 15px auto',
          md: '25px auto 15px auto',
        }}
      >
        {moduledata[2]?.titleText}
        {moduledata[2]?.titleText != undefined && (
          <Box
            textAlign="center"
            m="0 auto"
            mb="0.3rem"
            w={{ base: '80%', sm: '100%', md: '100%', lg: '100%' }}
          >
            <Image
              alt="kolam"
              title="kolam"
              src={`${config.imgPath}/d/46272/1652841553-sannidhi_kolam_darkred.png`}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SannidhiSpace;
